/* eslint-disable no-undef */
class Env {
  ENV_CREDENTIAL_CUSTOMER_ID = parseInt(process.env.REACT_APP_ENV_CREDENTIAL_CUSTOMER_ID ?? "0");
  ENV_CREDENTIAL_USERNAME = process.env.REACT_APP_ENV_CREDENTIAL_USERNAME;
  ENV_CREDENTIAL_PASSWORD = process.env.REACT_APP_ENV_CREDENTIAL_PASSWORD;
  ENV_COMMON_API_BASE_URL = process.env.REACT_APP_ENV_COMMON_API_BASE_URL;

  ENV_MI_OCR_SERVER_BASE_URL = process.env.REACT_APP_ENV_MI_OCR_SERVER_BASE_URL;
  ENV_OCR_RESOURCE_BASE_URL = `${window.location.protocol}//${window.location.host}/sdk/ocr/`;
  ENV_OCR_LICENSE_KEY = process.env.REACT_APP_ENV_OCR_LICENSE_KEY;

  ENV_FACE_SERVER_URL = process.env.REACT_APP_ENV_FACE_SERVER_URL || "/face/";
  ENV_FACE_SERVER_X_API_KEY = process.env.REACT_APP_ENV_FACE_SERVER_X_API_KEY;
  ENV_FACE_RESOURCE_BASE_URL = `${window.location.protocol}//${window.location.host}/sdk/face/models/`;
  ENV_AES_RESOURCE_BASE_URL = `${window.location.protocol}//${window.location.host}/sdk/aes256/`;
  ENV_API_URL = process.env.REACT_APP_ENV_API_URL || "/api/";
}

export default new Env();
